import { DatiVersionamentoDocumentoDTO } from "../dto/dati-versionamento-documentoDTO";
import { DatiVersionamentoDocumentoVO } from "../vo/dati-versionamento-documentoVO";
import { Injectable } from "@angular/core";
import { MapperInterface } from "./mapper-inteface";

@Injectable({
  providedIn: "root",
})
export class MapperVersionamentoDocumento
  implements
    MapperInterface<
      DatiVersionamentoDocumentoDTO,
      DatiVersionamentoDocumentoVO
    > {
  constructor() {}

  convertVoToDto(
    vo: DatiVersionamentoDocumentoVO
  ): DatiVersionamentoDocumentoDTO {
    if (vo != null) {
      const dto = new DatiVersionamentoDocumentoDTO();
      dto.data = vo.data;
      dto.idVersionePrecedente = vo.idVersionePrecedente;
      dto.idVersioneSuccessiva = vo.idVersioneSuccessiva;
      dto.versione = vo.versione;
      return dto;
    } else {
      return null;
    }
  }

  convertDtoToVo(
    dto: DatiVersionamentoDocumentoDTO
  ): DatiVersionamentoDocumentoVO {
    if (dto != null) {
      const vo = new DatiVersionamentoDocumentoVO();

      vo.data = dto.data;
      vo.idVersionePrecedente = dto.idVersionePrecedente;
      vo.idVersioneSuccessiva = dto.idVersioneSuccessiva;
      vo.versione = dto.versione;
      return dto;
    } else {
      return null;
    }
  }

  convertListVoToDto(
    autorizzazioneVOList: DatiVersionamentoDocumentoVO[]
  ): DatiVersionamentoDocumentoDTO[] {
    const autorizzazioneDTOList = new Array<DatiVersionamentoDocumentoDTO>();
    autorizzazioneVOList.forEach((vo) => {
      autorizzazioneDTOList.push(this.convertDtoToVo(vo));
    });

    return autorizzazioneDTOList || new Array<DatiVersionamentoDocumentoDTO>();
  }

  convertListDtoToVo(
    autorizzazioneDTOList: DatiVersionamentoDocumentoDTO[]
  ): DatiVersionamentoDocumentoVO[] {
    const autorizzazioneVOList = new Array<DatiVersionamentoDocumentoVO>();
    autorizzazioneDTOList.forEach((dto) => {
      autorizzazioneVOList.push(this.convertDtoToVo(dto));
    });

    return autorizzazioneVOList || new Array<DatiVersionamentoDocumentoVO>();
  }
}
